import qs from 'qs';
import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';

function useQuery() {
  const { search } = useLocation();

  return useMemo(() => qs.parse(search, { ignoreQueryPrefix: true }), [search]);
}

export default useQuery;
